import { IModelBase } from 'common-components'
import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IProviderType extends IModelBase {
  Value: string
}

@Injectable()
export class ProviderTypeODataService extends ODataService<IProviderType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProviderTypes'
  }
}
